import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AuditOutlinedSvg from "@ant-design/icons-svg/es/asn/AuditOutlined";
import AntdIcon from "../components/AntdIcon";
var AuditOutlined = function AuditOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AuditOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AuditOutlined.displayName = 'AuditOutlined';
}
export default /*#__PURE__*/React.forwardRef(AuditOutlined);